/* ========================================================================
   FAQ Block
 ========================================================================== */

app.faqBlock = (function () {
  'use strict';

  function init() {
    const items = document.querySelectorAll('.js-faqItem');
    if (items.length === 0) return;

    items.forEach((item) => {
      const link = item.querySelector('.faqBlock__question');
      const content = item.querySelector('.faqBlock__answer');

      link.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.classList.contains('is-active') === false) {
          item.classList.add('is-active');
          util.slideDown(content, 250);

          console.log(link);

          // DATALAYER
          window.dataLayer.push({
            event: 'faqClick',
            pageUrl: window.location.pathname,
            question: link.innerText,
          });
        } else {
          util.slideUp(content, 250, () => {
            item.classList.remove('is-active');
          });
        }
      });
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
